import { render, staticRenderFns } from "./showDetail.vue?vue&type=template&id=37218a85&scoped=true"
import script from "./showDetail.vue?vue&type=script&lang=js"
export * from "./showDetail.vue?vue&type=script&lang=js"
import style0 from "./showDetail.vue?vue&type=style&index=0&id=37218a85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37218a85",
  null
  
)

export default component.exports